import * as types from './types'
import storage from '@/plugins/storage'
export default {
  [types.RESET_LOOKUPS](state) {
    state.lookups = {}
  },
  [types.SET_LOOKUPS](state, [keys, lookups]) {
    let _lookups = {}
    for (let key of keys) {
      _lookups[key] = []
      for (let lookup of lookups) {
        if (lookup.key === key) {
          lookup.id = lookup.id
          lookup.value = lookup.intValue
          lookup.name = (lookup.text !== null) ? lookup.text : lookup.stringValue
          lookup.altValue = lookup.value
          lookup.stringValue = lookup.stringValue
          lookup.infoBubble = lookup.infoBubble
          _lookups[key].push(lookup)
        }
      }
    }
    state.lookups = JSON.parse(JSON.stringify(Object.assign(state.lookups, _lookups)))
  },
  [types.SET_LOOKUPS_ZEUS](state, [key, lookups]) {
    let _lookups = state.lookupsZeus
    if (_lookups[key] === undefined) {
      _lookups[key] = []
      for (let lookup of lookups) {
        let _value = null
        if (key === 'device.applayerprotocol') {
          _value = lookup.value
        } else {
          _value = lookup.id
        }
        let _lookup = {
          name: lookup.text,
          value: _value,
          altValue: lookup.value
        }
        _lookups[key].push(_lookup)
      }
      if (key === 'workorder.status') {
        storage.local.setItem(types.SESSION_WORKORDERSTATUS, JSON.stringify(_lookups[key]))
      } else if (key === 'workorder.cancelreason') {
        storage.local.setItem(types.SESSION_CANCELREASONS, JSON.stringify(_lookups[key]))
      } else if (key === 'workorder.calibratereason') {
        storage.local.setItem(types.SESSION_CALIBRATEREASONS, JSON.stringify(_lookups[key]))
      } else if (key === 'workorder.calibratesystem') {
        storage.local.setItem(types.SESSION_CALIBRATESYSTEMS, JSON.stringify(_lookups[key]))
      } else if (key === 'workorder.calibratefixture') {
        storage.local.setItem(types.SESSION_CALIBRATEFIXTURES, JSON.stringify(_lookups[key]))
      } else if (key === 'workorder.calibrateimage') {
        storage.local.setItem(types.SESSION_CALIBRATEIMAGES, JSON.stringify(_lookups[key]))
      } else if (key === 'workorder.calibratenote') {
        storage.local.setItem(types.SESSION_CALIBRATENOTES, JSON.stringify(_lookups[key]))
      } else if (key === 'configuration') {
        storage.local.setItem(types.SESSION_DYNAMIC_CONFIGURATION, JSON.stringify(_lookups[key]))
      }
    }
  },
  [types.SET_TIMEZONES](state, data) {
    state.timeZones = []
    let _timeZones = []
    for (let timezone of data) {
      timezone.value = timezone.name
      _timeZones.push(timezone)
    }
    state.timeZones = JSON.parse(JSON.stringify(Object.assign(state.timeZones, _timeZones)))
    storage.local.setItem(types.SESSION_TIMEZONES, JSON.stringify(state.timeZones))
  },
  [types.UPSERT_LOOKUP](state, [lookup, id]) {
    lookup.id = id
    let section = state.groups.filter(
      group => group.sectionName === lookup.section
    )
    if (section.length > 0) {
      let index = section[0].children.findIndex(i => i.id === lookup.id)
      if (index >= 0) {
        section[0].children[index] = {
          id: lookup.id,
          key: lookup.key,
          section: lookup.section,
          text: lookup.text,
          value: lookup.stringValue,
          intValue: lookup.intValue,
          dateValue: lookup.dateValue
        }
      } else {
        section[0].children.push({
          id: lookup.id,
          key: lookup.key,
          section: lookup.section,
          text: lookup.text,
          value: lookup.stringValue,
          intValue: lookup.intValue,
          dateValue: lookup.dateValue
        })
      }
    }
  },
  [types.DELETE_LOOKUP](state, lookup) {
    try {
      let section = state.groups.filter(
        group => group.sectionName === lookup.section
      )
      if (section.length > 0) {
        let index = section[0].children.findIndex(i => i.id === lookup.id)
        section[0].children.splice(index, 1)
      }
    } catch (e) {
    }
  },
  [types.SET_GROUPS](state, groups) {
    state.groups = groups
  },
  [types.UPSERT_GROUP](state, data) {
    let group = state.groups.filter(
      g => g.id === data.id
    )
    if (group.length > 0) {
      group[0].sectionName = data.text
    }
  },
  [types.SET_INSURANCE_COMPANIES](state, companies) {
    state.insuranceCompanies = []
    if (companies !== undefined && companies !== null) {
      for (let item of companies) {
        state.insuranceCompanies.push({
          name: item.name,
          value: item.id
        })
      }
    }
    storage.local.setItem(types.SESSION_INSURANCECOMPANIES, JSON.stringify(state.insuranceCompanies))
  },
  [types.SET_VEHICLE_MAKES](state, makes) {
    state.vehicleMakes = []
    if (makes !== undefined && makes !== null) {
      for (let item of makes) {
        state.vehicleMakes.push({
          name: item.text,
          value: item.id
        })
      }
    }
    storage.local.setItem(types.SESSION_VEHICLEMAKES, JSON.stringify(state.vehicleMakes))
  },
  [types.SET_ODOMETERUNITS](state, units) {
    state.odometerunits = []
    if (units !== undefined && units !== null) {
      for (let item of units) {
        state.odometerunits.push({
          name: item.text,
          value: item.id
        })
      }
    }
    storage.local.setItem(types.SESSION_ODOMETERUNITS, JSON.stringify(state.odometerunits))
  },
  [types.SET_DAMAGEPOSITIONS](state, positions) {
    state.damagepositions = positions
    storage.local.setItem(types.SESSION_DAMAGEPOSITIONS, JSON.stringify(state.damagepositions))
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/mutations.js